export const USER_IMAGES = {
  tokyo1: 'https://customer-assets.emergentagent.com/job_ptexports-visual-hub/artifacts/gxfjq3by_2024_11_23_Tokyo_Archives_Project_0_345-Edit.jpg',
  suede: 'https://customer-assets.emergentagent.com/job_ptexports-visual-hub/artifacts/symupmg2_2024_11_23_Tokyo_Archives_Project_0_326-Edit.jpg',
  blackLeather: 'https://customer-assets.emergentagent.com/job_ptexports-visual-hub/artifacts/s3pkqkow_2024_11_23_Tokyo_Archives_Project_0_368-Edit.jpg',
  studio1: 'https://customer-assets.emergentagent.com/job_ptexports-visual-hub/artifacts/3tlaa41f_P1033082.jpg',
  studio2: 'https://customer-assets.emergentagent.com/job_ptexports-visual-hub/artifacts/v2qrqko4_P1032905.jpg',
  studio3: 'https://customer-assets.emergentagent.com/job_ptexports-visual-hub/artifacts/gs7uqx8j_P1033010.jpg',
};

export const GALLERY = [
  USER_IMAGES.tokyo1,
  USER_IMAGES.suede,
  USER_IMAGES.blackLeather,
  USER_IMAGES.studio1,
  USER_IMAGES.studio2,
  USER_IMAGES.studio3,
];

export const BROWN = {
  full: USER_IMAGES.suede,
  chest: '/images/brown/chest.jpg',
  sleeve: '/images/brown/sleeve.jpg',
  zip: '/images/brown/zip.jpg',
  collar: '/images/brown/collar.jpg',
  torsoWide: '/images/brown/torso_wide.jpg',
  inspect: '/images/brown/inspect.jpg',
};

export const NAPPA_TEXTURE = 'https://static.prod-images.emergentagent.com/jobs/18a61f8f-6c23-40c8-92f0-03758dc96ee8/images/7d72544b70579550a9cc2558bb0ed4bbe6e6bb2cb6df9e8fdd239b5a76c03cae.jpeg';

// Mid-tone cognac/tan full-grain leather — hero background + 3D material map (quiet luxury)
export const HERO_LEATHER = 'https://images.unsplash.com/photo-1752574779992-0216745eb170?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920';

export const STOCK = {
  rawLeather: 'https://images.unsplash.com/photo-1575722290270-626b0208df99?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwZGFyayUyMGxlYXRoZXIlMjB0ZXh0dXJlJTIwbWFjcm98ZW58MHx8fHwxNzg1OTI5MTQyfDA&ixlib=rb-4.1.0&q=85',
  darkTexture: 'https://images.unsplash.com/photo-1755541608566-0340d4efca0d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwZGFyayUyMGxlYXRoZXIlMjB0ZXh0dXJlJTIwbWFjcm98ZW58MHx8fHwxNzg1OTI5MTQyfDA&ixlib=rb-4.1.0&q=85',
  brownStitched: 'https://images.unsplash.com/photo-1741086154510-522e68f76933?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxwcmVtaXVtJTIwZGFyayUyMGxlYXRoZXIlMjB0ZXh0dXJlJTIwbWFjcm98ZW58MHx8fHwxNzg1OTI5MTQyfDA&ixlib=rb-4.1.0&q=85',
  sewingMachine: 'https://images.unsplash.com/photo-1662405964457-3cda8060b010?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHx0YWlsb3IlMjBzZXdpbmclMjBtYWNoaW5lJTIwY2xvc2UlMjB1cHxlbnwwfHx8fDE3ODU5MjkxNTJ8MA&ixlib=rb-4.1.0&q=85',
  zipperMacro: 'https://images.unsplash.com/photo-1596832772762-78e213deff5f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHx6aXBwZXIlMjBtYWNybyUyMG1ldGFsJTIwbGVhdGhlcnxlbnwwfHx8fDE3ODU5MjkxNTl8MA&ixlib=rb-4.1.0&q=85',
  factory: 'https://images.unsplash.com/photo-1589793463357-5fb813435467?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxjbG90aGluZyUyMGZhc2hpb24lMjBmYWN0b3J5JTIwd29ya2Vyc3xlbnwwfHx8fDE3ODU5MjkxNTl8MA&ixlib=rb-4.1.0&q=85',
};

export const HOME_PANELS = [
  { src: '/images/brown/chest.jpg', label: 'SUEDE BOMBER — TAN', idx: '01' },
  { src: '/images/home/black.jpg', label: 'BIKER — NOIR', idx: '02' },
  { src: '/images/home/cream.jpg', label: 'FIELD JACKET — IVORY', idx: '03' },
];

const ENQUIRY_MESSAGE = 'Hello Pakkar Tanveer Exports — we are interested in sourcing premium leather jackets for our brand. Please share your catalogue, MOQ and production details.';

export const CONTACT = {
  whatsapp: 'https://api.whatsapp.com/send?phone=919840951767',
  whatsappEnquiry: `https://api.whatsapp.com/send?phone=919840951767&text=${encodeURIComponent(ENQUIRY_MESSAGE)}`,
  email: 'mailto:tanveer@ptexports.com',
  phoneDisplay: '+91 98409 51767',
  emailDisplay: 'tanveer@ptexports.com',
};
